<template>
  <div class="contact">
   <h2>Stay in touch!</h2>
   <p>Email: <a href="mailto:malik.blackman11@gmail.com" target="_blank">malik.blackman11@gmail.com</a></p>
   <p>Instagram: <a href="https://www.instagram.com/blackstarrr_11" target="_blank">Malik Blackman</a></p>
   <p>LinkedIn: <a href="https://www.linkedin.com/in/malik-blackman/" target="_blank">Malik Blackman</a></p>
 </div>
</template>

<style lang="scss">
.contact a {
  text-decoration: underline;
}
</style>
